import styled from 'styled-components';

/**
 * PageHeader Components
 *
 * Reusable styled components for page headers.
 * Use these components to maintain consistent header styling across pages.
 *
 * Usage:
 * import { HeaderContainer, HeaderTitle, HeaderSubtitle } from 'components/PageHeader';
 *
 * <Card>
 *   <HeaderContainer>
 *     <PageHeaderIcon icon="users" />
 *     <div>
 *       <HeaderTitle>Page Title</HeaderTitle>
 *       <HeaderSubtitle>Subtitle text</HeaderSubtitle>
 *     </div>
 *   </HeaderContainer>
 * </Card>
 */

// Container for page header content (icon + title/subtitle)
export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

// Main page title - h1 with theme-aware colors
export const HeaderTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.textGray?.primary || '#ffffff'
      : props.theme.colors?.blueBlack || '#000033'};
  margin: 0;
  font-family: Arial, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Ubuntu, sans-serif;
`;

// Page subtitle - smaller text below the title
export const HeaderSubtitle = styled.p`
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748B')};
  margin: 4px 0 0 0;
`;

// Wrapper that spreads items to edges (useful for header with actions on right)
export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export default {
  HeaderContainer,
  HeaderTitle,
  HeaderSubtitle,
  HeaderWrapper,
};
